import D12Game from "./D12Game";

let over = false;
let permutations = 0;
let others = 0;

export default function solve(startingBoard, hp) {
  const game = new D12Game(startingBoard, hp);
  permutate(game);
  if (!over) {
    return 'Unwinnable, checked '+permutations+' possible permutations until death';
  } else {
    return {start: game, win: over, permutations, others};
  }
}

function permutate(game)
{
  game.getPossibleMoves().forEach(moveDirection => {
    if (moveDirection === 'DEAD') {
      permutations++;
      //console.log("Dead after "+game.turns.length);
      return;
    }
    if (moveDirection === 'ATTACK') {
      console.log("Found winning permutation", game);
      if (!over || game.hp > over.hp) {
        over = game;
      } else {
        others++;
      }
      return;
    }
    if (over && permutations > 2500000) {
      return;
    }
    let newGame = game.getClone();
    newGame.move(moveDirection);
    permutate(newGame);
  });
}
